import { Component, OnInit } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/core/common.service';

@Component({
  selector: 'eos-phone-field',
  templateUrl: './phone-field.component.html',
  styleUrls: ['./phone-field.component.css']
})
export class PhoneFieldComponent extends FieldType implements OnInit {

  countryCodes: Observable<any[]>;
  phNumberControl: AbstractControl;
  countryCode: AbstractControl;
  phoneKey: string = 'phoneNumber';
  codeKey:string = 'countryCode';

  constructor(private commonService: CommonService) {
    super();
  }

  ngOnInit() {
    
    if(this.to.phoneKey && this.to.phoneKey.length >0){
        this.phoneKey = this.to.phoneKey;
    }
    if(this.to.codeKey && this.to.codeKey.length >0){
        this.codeKey = this.to.codeKey;
    }

    this.phNumberControl = this.formControl.get(this.phoneKey);
    this.countryCode = this.formControl.get(this.codeKey);

    this.getCountrycodes();
    if (this.to.restrictedDialCode && this.to.restrictedDialCode.length > 0) {
      this.countryCode.setValue(this.to.restrictedDialCode);
     
    }
  }

  addCustomCode(countryCode): {} | boolean {
    const regex = /^(\+)([0-9]*)$/;
    if (countryCode.match(regex)) {
      return {
        display_name: countryCode,
        dial_code: countryCode,
        code: countryCode,
        icon: countryCode
      };
    } else {
      return false;
    }
  }

  getCountrycodes() {
    this.countryCodes = this.commonService.getCountryCodes();
  }

}
